var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 2.667h-1.334V1.333H4.667v1.334H3.333v-2A.667.667 0 014 0h8a.667.667 0 01.667.667v2zM12.667 3.333H3.333A3.337 3.337 0 000 6.667V12a.667.667 0 00.667.667h2.666v2.666A.667.667 0 004 16h8a.666.666 0 00.667-.667v-2.666h2.666A.667.667 0 0016 12V6.667a3.338 3.338 0 00-3.333-3.334zm-1.334 11.334H4.667V10h6.666v4.667zM12 7.333A.667.667 0 1112 6a.667.667 0 010 1.333z",
    fill: "#000"
  })));
}
export default SvgPrint;